(function () {
  function setup(wrapper) {
    var track = wrapper.querySelector('.ticker__track');
    var original = track && track.querySelector('.ticker__content:not([data-clone])');   /* [the one real copy from Liquid] */
    if (!track || !original || track.dataset.tickerReady) return;                        /* [never set up the same ticker twice] */
    track.dataset.tickerReady = '1';

    function fill() {
      track.querySelectorAll('.ticker__content[data-clone]').forEach(function (c) { c.remove(); });   /* [clear old copies before re-measuring] */
      var copyWidth = original.getBoundingClientRect().width;                                        /* [width of one full set of messages] */
      if (!copyWidth) return;
      var needed = Math.ceil(wrapper.offsetWidth / copyWidth) + 1;                                   /* [enough copies to cover the screen, plus one to slide in] */
      for (var i = 0; i < needed; i++) {
        var clone = original.cloneNode(true);
        clone.setAttribute('data-clone', '');
        clone.setAttribute('aria-hidden', 'true');                                                   /* [screen readers skip copies: each message is read once] */
        clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
          el.removeAttribute('data-shopify-editor-block');                                           /* [theme editor: clicking a copy doesn't select the wrong block] */
        });
        track.appendChild(clone);
      }
      track.style.setProperty('--ticker-shift', copyWidth + 'px');                                   /* [the CSS animation slides exactly this far per loop] */
    }

    fill();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fill);                     /* [re-measure once the web font loads, since text width changes] */
    var timer;
    window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(fill, 250); });   /* [re-fit after resizing or rotating the phone] */
    wrapper.addEventListener('touchstart', function () { wrapper.classList.add('is-paused'); }, { passive: true });   /* [hold to read on mobile] */
    wrapper.addEventListener('touchend', function () { wrapper.classList.remove('is-paused'); }, { passive: true });
  }

  function init(root) { (root || document).querySelectorAll('.ticker-wrapper').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });              /* [theme editor re-renders the section after edits] */
})();
